export default "__VITE_ASSET__uPXz3vNd__"